export const ID = 'id';
export const COMPANY_ID = 'companyId';
export const DESCRIPTION = 'description';
export const NAME = 'name';
